// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"443":"about","631":"contact"}[chunkId] + "." + {"443":"41554de1","631":"c445e1ea"}[chunkId] + ".css";
};